import { render } from "./CatCuentaContableForm.vue?vue&type=template&id=745b867c&scoped=true"
import script from "./CatCuentaContableForm.vue?vue&type=script&lang=js"
export * from "./CatCuentaContableForm.vue?vue&type=script&lang=js"

import "./CatCuentaContableForm.vue?vue&type=style&index=0&id=745b867c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745b867c"]])

export default __exports__